"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createTransformRoutes = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var createTransformRoutes = function createTransformRoutes(isActiveRouteChecker, containsActiveRouteChecker) {
  return function (routes) {
    return routes && routes.map && routes.map(function (route) {
      return _objectSpread({}, route, {
        routes: createTransformRoutes(isActiveRouteChecker, containsActiveRouteChecker)(route.routes),
        key: route.key || JSON.stringify(route),
        isSelected: isActiveRouteChecker(route),
        isOpen: route.isOpen !== undefined ? // it can be already opened, eg. by user
        route.isOpen : // it is only selected if route is matched
        containsActiveRouteChecker(route)
      });
    });
  };
};

exports.createTransformRoutes = createTransformRoutes;
var _default = createTransformRoutes;
exports.default = _default;